export const formBlockWithoutLineCss = {
  paddingBottom: "0px",
};

export const formRowCss = {
  width: "100%",
  display: "flex" as const,
  flexDirection: "row" as const,
  justifyContent: "space-between" as const,
  alignItems: "start" as const,
  flexWrap: "wrap" as const,
};

export const subTitleCss = {
  fontSize: "20px",
  lineHeight: "24px",
  fontWeight: "700",
};

export const inputPublicationCss = {
  root: {
    width: "360px",
    marginBottom: "24px",
  },
  input: {
    width: "360px",
  },
  label: {
    "& > div > label > svg": {
      display: "none" as const,
    },
  },
};

export const datePickerPublicationCss = {
  border: "solid blue 1px",
  root: {
    width: "360px",
    marginBottom: "24px",

    "& > div > span > svg": {
      display: "none" as const,
    },
  },
};
